import React, { useState } from "react";
import Chart from "react-apexcharts";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";

const dropdownStyle = {
  padding: "5px 10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "14px",
};

const nameExpan = {
  lessThanEqual5: "≤5 min",
  between5And10: "5 to 10 mins",
  greaterThan10: "Greater than 10mins",
};

const OnTimeStartDelay = () => {
  const [selectedType, setSelectedType] = useState("lessThanEqual5");
  const { onTimeStartDelay } = useSelector((state) => state.doctorDashboard);

  const getVetList = () => {
    return onTimeStartDelay?.length > 0
      ? onTimeStartDelay?.map((li) => li?.doctor ?? "")
      : [];
  };

  const totalDelayedAppointments = () => {
    return onTimeStartDelay?.length > 0
      ? onTimeStartDelay?.map((li, i) => li?.delayedAppointmentsCount ?? 0)
      : [];
  };

  const data = {
    categories: getVetList(),
    cat: totalDelayedAppointments(),
  };

  const series = [
    {
      name: "Delayed",
      data: totalDelayedAppointments(),
    },
  ];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
    },
    colors: ["#0052CC", "#B45AF2", "#F3F4F6"],
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 10,
        barHeight: "40%",
      },
    },

    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {},
      style: {
        colors: ["#000"],
        fontSize: "13px",
        fontWeight: 500,
      },
      offsetX: 0, // Reset offset
      textAnchor: "start",
      dropShadow: {
        enabled: false,
      },
    },

    stroke: { width: 0 },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const hoverData = onTimeStartDelay?.[dataPointIndex] ?? {};
        const category = data.categories[dataPointIndex];
        let tooltipContent =
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          category +
          "</div>" +
          '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
          '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-marker" style="background-color: ' +
          w.globals.colors[0] +
          '; margin-right: 5px; display: inline-block; width: 8px; height: 8px; border-radius: 50%;"></span>' +
          '<span class="apexcharts-tooltip-text-y-label">Avg delay mins: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          hoverData?.avgDelayRounded +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-marker" style="background-color: ' +
          w.globals.colors[1] +
          '; margin-right: 5px; display: inline-block; width: 8px; height: 8px; border-radius: 50%;"></span>' +
          `<span class="apexcharts-tooltip-text-y-label">% sessions starting ${nameExpan?.[selectedType]} late: </span>` +
          '<span class="apexcharts-tooltip-text-y-value">' +
          hoverData?.delayRanges?.[selectedType]?.percentage +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Total: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          hoverData?.delayRanges?.[selectedType]?.count +
          "</div>" +
          "</div>" +
          "</div>";

        return tooltipContent;
      },
    },
    xaxis: {
      categories: data.categories,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      max: 115,
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "14px",
          fontWeight: 500,
          colors: ["#000"],
        },
      },
    },
    legend: { show: false },
    grid: { show: false },
    annotations: {
      points: data?.categories.map((category, index) => {
        const actData = onTimeStartDelay?.find(
          (li) => li?.doctor?.toLowerCase() === category?.toLowerCase()
        );
        return {
          x: 110, // Fixed position at the right
          y: category,
          marker: {
            size: 0,
            strokeWidth: 0,
            fillOpacity: 0,
            strokeOpacity: 0,
          },
          label: {
            text: `${actData?.delayedAppointmentsCount ?? 0}`,
            offsetX: 0,
            style: {
              background: "transparent",
              color: "#000",
              fontSize: "13px",
              fontWeight: 500,
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
              },
            },
            borderWidth: 0,
          },
        };
      }),
    },
  };

  return (
    <div className="conditions-page">
      {/* Content */}
      <div className="content">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ marginBottom: "10px" }}>On-time Start & Delay</h3>
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            style={dropdownStyle}
          >
            <option value="lessThanEqual5">≤5 min</option>
            <option value="between5And10">5 to 10 mins</option>
            <option value="greaterThan10">Greater than 10mins</option>
          </select>
        </div>

        <div className="chart-container">
          {/* <div className="total-count">
            <span>Total:</span>
            <span>1070</span>
          </div> */}
          <Chart
            options={options}
            series={series}
            width="100%"
            type="bar"
            height={300}
          />
        </div>

        {/* Total Count */}
      </div>
    </div>
  );
};

export default OnTimeStartDelay;
